// extracted by mini-css-extract-plugin
export default {"container":"btns_container__2vY6K"};